export { SoftHyphens } from './soft-hyphens.component';
